import { Component, OnInit, effect, inject, signal } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { assert } from '../../../../../../core/assert/assert';
import { InvoiceStateService } from '../../state-and-data-handling/invoice-state.service';
import {
  FormControlNameRecord,
  FormControlValue,
} from '../../../../../../shared/data-types/form-types';

@Component({
  selector: 'app-edit-document-section-base-styling',
  standalone: false,
  templateUrl: './edit-document-section-base-styling.component.html',
})
export class EditDocumentSectionBaseStylingComponent implements OnInit {
  readonly baseStylingForm = signal<FormGroup | null>(null);
  public formControlNames: FormControlNameRecord = {
    ThemeColor: 'themeColor',
    FooterBackgroundColor: 'footerBackgroundColor',
  };

  // DI
  private readonly invoiceStateService = inject(InvoiceStateService);
  private readonly formBuilder = inject(FormBuilder);

  constructor() {
    effect(() => {
      const themeProps = this.invoiceStateService.themeProps();
      if (themeProps === null) {
        return;
      }

      this.baseStylingForm()!.patchValue({
        [this.formControlNames.ThemeColor]: themeProps.themeColor,
        [this.formControlNames.FooterBackgroundColor]: themeProps.footerBackgroundColor,
      });
    });
  }

  ngOnInit(): void {
    this.buildForm();
  }

  public formValueChanged([value, formCtrlName]: FormControlValue): void {
    assert(typeof formCtrlName !== 'undefined', `Form control name is undefined: ${formCtrlName}`);
    this.invoiceStateService.updateTheme(formCtrlName, (value as string) ?? '');
  }

  private buildForm(): void {
    this.baseStylingForm.set(
      this.formBuilder.group({
        [this.formControlNames.ThemeColor]: [],
        [this.formControlNames.FooterBackgroundColor]: [],
      }),
    );
  }
}
